import NotificationMessage from './NotificationMessage';

export default NotificationMessage;
